/**
 * Test ID utilities for Switch component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for switch elements
 * @param identifier - Switch identifier (name, id, or 'unnamed')
 * @returns Test ID string
 */
export const setSwitchTestId = (identifier: string): string => generateTestId("Switch", identifier.replace(/\s+/g, "-").toLowerCase());
